<app-page-header [heading]="'Purchase VAT Report'" [icon]="'fa-file-excel-o'" style="height:100px;"></app-page-header>
<div *ngIf="user_rights.ADD == '1'" class="page-panel">
  <div class="clearfix"></div>
  <div class="clearfix"></div>
  <div class="row">
    <div class="form-group col-lg-4">
      <label>From</label>
      <input (ngModelChange)="fromdate = $event" [max]="getToday()" [ngModel]="fromdate | date:'yyyy-MM-dd'"
             class="form-control " id="date" name="date" type="date">

    </div>
    <div class="form-group col-lg-4">
      <label>To</label>
      <input (ngModelChange)="todate = $event" [max]="getToday()" [ngModel]="todate | date:'yyyy-MM-dd'"
             class="form-control " id="todate" name="todate" type="date">
    </div>
    <div class="form-group col-lg-4">
      <label></label><br>
      <button (click)="listVatReport();" class="btn btn-info btn-sm ng-star-inserted" type="button">&nbsp;Search&nbsp;
      </button>

    </div>
    <div class="clearfix"></div>
    <div class="clearfix"></div>

    <div class="text-right col-lg-12 pull-right">
      <button *ngIf="(stock_data | json) != '[]'" (click)="ExportToExcel()" class="btn btn-info btn-sm ng-star-inserted" title="Export as XLSX">Export to
        XLSX&nbsp;<i class="fa fa-file-excel-o"></i></button>&nbsp;
        <app-report-pdf *ngIf="(stock_data | json) != '[]'" targetId="printReport" fileName="Purchase_vat_report.pdf" titleName="PURCHASE VAT REPORT"></app-report-pdf>
    </div>
    <div class="clearfix"></div>
    <div class="clearfix"></div>
    <div class=" col-12" id="printReport">
      <table #table class=" table tbl table-bordered">
        <thead>
        <tr class="text-center">
          <th width="1%">Sl</th>
          <th width="10%">Invoice Date</th>
          <th>Invoice Number</th>
          <th>Supplier Name</th>
          <th>VAT No</th>
          <th width="8%">HSN Code</th>
          <th width="20%">Item</th>
          <th width="5%">Quantity</th>
          <th width="8%">Rate</th>
          <th width="2%">VAT%</th>
          <th width="5%">VAT</th>
          <th width="8%">Total</th>
        </tr>
        <tr *ngIf="(stock_data | json) == '[]'">
          <td class="text-center" colspan="13">No data to list</td>
        </tr>
        </thead>
        <tbody>
        <ng-container *ngFor="let stock of stock_data;let j=index">
          <tr *ngFor="let item of stock.ITEM;let i=index">
            <ng-container *ngIf="i == 0">
              <td [attr.rowspan]="stock.ITEM.length" class="text-center">{{ j + 1 }}</td>
              <td [attr.rowspan]="stock.ITEM.length"> {{ utils.date(stock.INVOICE_DATE) }}</td>
              <td (click)="opens(purchasedetails);purached_items(stock)" [attr.rowspan]="stock.ITEM.length"
                  class="text-primary"
                  style="cursor: pointer">{{ stock.INVOICE_NUMBER }}
              </td>
              <td [attr.rowspan]="stock.ITEM.length"> {{ stock.VENDOR_NAME }}</td>
              <td [attr.rowspan]="stock.ITEM.length"> {{ stock.VAT_NO }}</td>
            </ng-container>
            <td class="text-center"> {{ item.HSN_CODE }}</td>
            <td> {{ item.TRADE_NAME }}</td>
            <td class="text-center"> {{ item.QUANTITY }}</td>
            <td class="text-right"> {{ item.RATE }}</td>
            <td class="text-center"> {{ item.VAT }}</td>
            <td class="text-right"> {{ item.VAT_AMOUNT }}</td>
            <td class="text-right"> {{ item.TOTAL }}</td>
          </tr>
        </ng-container>
        </tbody>
        <tfoot>
        <tr style="font-size: 15px;font-weight: bolder;">
          <td colspan="6">Grand Total</td>
          <td class="text-right">{{ (total_exclude) | number : '1.2-2' }}</td>
          <td></td>
          <td class="text-right">{{ (vat_total) | number : '1.2-2' }}</td>
          <td class="text-right">{{ (total_include) | number : '1.2-2' }}</td>
        </tr>
        </tfoot>

      </table>
    </div>
  </div>
</div>
<ng-template #purchasedetails let-modal>
  <div class="modal-header">
    <div class="pull-right">
      <h5 class="modal-title" id="modal-basic-title">
        <ng-container *ngIf="purchased && purchased.VENDOR_NAME">{{ purchased.VENDOR_NAME }}</ng-container>
      </h5>
    </div>
    <div class="pull-right text-right">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </div>
    <button (click)="modal.dismiss('Cross click')" aria-label="Close" class="close" type="button">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="tab-pane active">
      <div class="tab-content">
        <div class="panel-body">
          <table class="table tbl table-bordered table-hover">
            <thead>
            <tr class="text-center">
              <th>Sl</th>
              <th width="25%">Particular</th>
              <th width="5%">Purchased qty</th>
              <th width="5%">Freebie qty</th>
              <th>Total Qty</th>
              <th>UOM</th>
              <th>Unit Price</th>
              <th>Retail Price</th>
              <th>Amount</th>
              <th>VAT Amount</th>
              <th>Gross Amount</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let item of item_list;let i=index">
              <td class="text-center">{{ 1 + i }}</td>
              <td> {{ item.TRADE_NAME }}</td>
              <td>{{ item.PURCHASED_QUANTITY }}</td>
              <td>{{ item.FREEBIE_QUANTITY }}</td>
              <td>{{ item.QUANTITY }}</td>
              <td>{{ item.UNIT_DESC }}</td>
              <td class="text-right">{{ item.UNIT_PRICE }}</td>
              <td class="text-right">{{ item.MRP }}</td>
              <td class="text-right">{{ item.AMOUNT }}</td>
              <td class="text-right">{{ item.VAT_AMOUNT }}</td>
              <td class="text-right">{{ item.GROSS_AMOUNT }}</td>
            </tr>

            </tbody>
            <tfoot>
            <ng-container *ngIf="purchased && purchased.VENDOR_STATECODE == 32">
              <tr>
                <td class="text-right" colspan="13">Gross Total</td>
                <td class="text-right">{{ price_total |  number : '1.2-2' }}</td>
              </tr>
              <tr *ngIf="purchased">
                <td class="text-right" colspan="13">Freight Charge</td>
                <td class="text-right">{{ purchased.FREIGHT_CHARGE |  number : '1.2-2' }}</td>
              </tr>
              <tr *ngIf="purchased">
                <td class="text-right" colspan="13">Discount</td>
                <td class="text-right">{{ purchased.DISCOUNT |  number : '1.2-2' }}</td>
              </tr>
              <tr *ngIf="purchased">
                <td class="text-right" colspan="13">Net Total</td>
                <td class="text-right">{{ net_total |  number : '1.2-2' }}</td>
              </tr>
            </ng-container>
            <ng-container *ngIf="purchased && purchased.VENDOR_STATECODE  !== 32">
              <tr>
                <td class="text-right" colspan="12">Gross Total</td>
                <td class="text-right">{{ price_total |  number : '1.2-2' }}</td>
              </tr>
              <tr *ngIf="purchased">
                <td class="text-right" colspan="12">Freight Charge</td>
                <td class="text-right">{{ purchased.FREIGHT_CHARGE |  number : '1.2-2' }}</td>
              </tr>
              <tr *ngIf="purchased">
                <td class="text-right" colspan="12">Discount</td>
                <td class="text-right">{{ purchased.DISCOUNT |  number : '1.2-2' }}</td>
              </tr>
              <tr *ngIf="purchased">
                <td class="text-right" colspan="12">Net Total</td>
                <td class="text-right">{{ net_total |  number : '1.2-2' }}</td>
              </tr>
            </ng-container>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </div>
</ng-template>
